import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CustomerLogos } from '../components/CustomerLogos';
import { FeaturesSection } from '../components/FeaturesSection';
import { VCLogos } from '../components/VCLogos';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <>
      <HeroSection data-id="element-391" />
      <CustomerLogos data-id="element-392" />
      <FeaturesSection data-id="element-393" />
      <VCLogos data-id="element-394" />
      <CTABanner data-id="element-395" />
    </>;
}